import { GameState, GlobalState } from "./shared/util/GlobalState";
import { soundManager } from "./shared/UI/SoundManager";
import MathUtils from "./shared/util/MathUtils";
import { SoundInstance } from "./shared/UI/SoundManagerUtils";

class GameStateSoundManager {
    private static _instance: GameStateSoundManager;

    private _musicMain: SoundInstance = new SoundInstance();
    private _musicBonus: SoundInstance = new SoundInstance();
    private _musicMainBaseVolume: number = 0;
    private _musicBonusBaseVolume: number = 0;

    public get musicMain(): SoundInstance {
        return this._musicMain;
    }
    public get musicBonus(): SoundInstance {
        return this._musicBonus;
    }

    public constructor() {
        document.addEventListener("BONUS_START", () => { this.updateBgMusic('bonusStart'); });
        document.addEventListener("BONUS_END", () => { this.updateBgMusic('bonusEnd'); });
        document.addEventListener("TOTAL_WIN", () => { this.updateBgMusic('none'); });
    }

    public static getInstance(): GameStateSoundManager {
        if (!GameStateSoundManager._instance) {
            GameStateSoundManager._instance = new GameStateSoundManager();
        }
        return GameStateSoundManager._instance;
    }

    public updateBgMusicVolume(volume?: number): void {
        switch (GlobalState.getInstance().state) {
            case GameState.MAIN:
                volume = MathUtils.clamp(volume ?? this._musicMainBaseVolume, 0, 1);
                soundManager.setSoundInstanceVolume(this._musicMain, volume);
                break;
            case GameState.BONUS:
                volume = MathUtils.clamp(volume ?? this._musicBonusBaseVolume, 0, 1);
                soundManager.setSoundInstanceVolume(this._musicBonus, volume);
                break;
        }
    }

    public async updateBgMusic(command: 'none' | 'gameStart' | 'bonusStart' | 'bonusEnd'): Promise<void> {
        switch (command) {
            case 'none':
                if (this._musicBonus.tryGetMediaInstance()) {
                    soundManager.setSoundInstanceVolume(this._musicBonus, 0, 2, () => {
                        soundManager.stopSoundInstance(this._musicBonus);
                        this._musicBonus.reset();

                        soundManager.playSound("totalWin");
                    });
                }
                break;
            case 'gameStart':
            case 'bonusEnd':
                console.log("Ended Bonus");

                if (this._musicBonus.tryGetMediaInstance()) {
                    soundManager.stopSoundInstance(this._musicBonus);
                    this._musicBonus.reset();
                }

                const musicMain: SoundInstance | undefined = await soundManager.playSound("musicMain");
                if (musicMain) {
                    this._musicMain = musicMain;
                    this._musicMainBaseVolume = musicMain.getBaseVolume();
                }

                break;
            case 'bonusStart':
                console.log("Started Bonus");

                if (this._musicMain.tryGetMediaInstance()) {
                    soundManager.stopSoundInstance(this._musicMain);
                    this._musicMain.reset();
                }

                const musicBonus: SoundInstance | undefined = await soundManager.playSound("musicBonus");
                if (musicBonus) {
                    this._musicBonus = musicBonus;
                    this._musicBonusBaseVolume = musicBonus.getBaseVolume();
                }

                await soundManager.playSound("bonusCollect");

                break;
        }
    }
}

export const gameStateSoundManager = GameStateSoundManager.getInstance();
